var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.525 18.0248C9.19167 18.2415 8.854 18.2538 8.512 18.0618C8.17067 17.8705 8 17.5748 8 17.1748V6.82484C8 6.42484 8.17067 6.12884 8.512 5.93684C8.854 5.7455 9.19167 5.75817 9.525 5.97484L17.675 11.1498C17.975 11.3498 18.125 11.6332 18.125 11.9998C18.125 12.3665 17.975 12.6498 17.675 12.8498L9.525 18.0248ZM10 15.3498L15.25 11.9998L10 8.64984V15.3498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d4add171d7e60062151d1bbb31d5dd27.svg";
export { ForwardRef as ReactComponent };